import * as bootstrap from 'bootstrap/dist/js/bootstrap';

document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById('popup-notifications-modal');
  if (!modal) { return; }

  var bsModal = new bootstrap.Modal(modal);
  bsModal.show();
});